// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"328":"d5d2a7ad","423":"2311e56a","564":"b14e15b1","917":"3aec682e"}[chunkId] + ".chunk.css";
};